// @flow
export const BUTTON_OFF = '1';
export const BUTTON_ON = '2';
export const CAMERA_OFF = 'J';
export const CAMERA_ON = 'K';
export const CONTACT_SENSOR_CLOSED = 'U';
export const CONTACT_SENSOR_OPEN = 'V';
export const COOLING = 'F';
export const FAN_OFF = 'B';
export const FAN_ON = 'C';
export const HEATING_OFF = 'i';
export const HEATING_ON = 'j';
export const HEATING_OFF_NA = 'Q';
export const HEATING_ON_NA = 'R';
export const HOT_WATER_OFF = 'k';
export const HOT_WATER_ON = 'l';
export const HUMIDITY = 'A';
export const LIGHT_OFF = 'u';
export const LIGHT_ON = 'v';
export const LEAK_SENSOR_OFF = 'S';
export const LEAK_SENSOR_ON = 'T';
export const MOTION_SENSOR_OFF = 'q';
export const MOTION_SENSOR_ON = 'r';
export const NEW_HUB = 'b';
export const OLD_HUB = 'a';
export const RECEIVER_DUAL = 'd';
export const RECEIVER_SINGLE = 'c';
export const SIGNAL_BOOSTER_OFF = 'h';
export const SIGNAL_BOOSTER_ON = 'N';
export const SIGNAL_BOOSTER2_OFF = 'O';
export const SIGNAL_BOOSTER2_ON = 'P';
export const SENCE_OFF = 'L';
export const SENCE_ON = 'M';
export const SMART_PLUG_OFF = 'o';
export const SMART_PLUG_ON = 'p';
export const SMART_PLUG_OFF_NA = 'G';
export const SMART_PLUG_ON_NA = 'H';
export const SMART_PLUG_OFF_IN = '3';
export const SMART_PLUG_ON_IN = '4';
export const SMART_PLUG_OFF_EU = '5';
export const SMART_PLUG_ON_EU = '6';
export const SOCKET_DUO_EU = '}';
export const SOCKET_DUO_IN = '{';
export const SOCKET_DUO_NA = ']';
export const SOCKET_DUO = '[';
export const SOCKET_OFF_GENERIC = 'w';
export const SOCKET_ON_GENERIC = 'x';
export const SOCKET_OFF = '7';
export const SOCKET_ON = '8';
export const SOCKET_OFF_NA = '9';
export const SOCKET_ON_NA = '0';
export const SOCKET_OFF_IN = '!';
export const SOCKET_ON_IN = '@';
export const SOCKET_OFF_EU = '$';
export const SOCKET_ON_EU = '%';
export const SWITCH_OFF = 'y';
export const SWITCH_ON = 'z';
export const STAT1 = 'e';
export const STAT2 = 'f';
export const STAT3 = 'g';
export const STAT3_ON = '(';
export const THERMOMETER = 'I';
export const WATER_FLOW_OFF = 'X';
export const WATER_FLOW_ON = 'W';



// WEBPACK FOOTER //
// ./src/core/constants/icons/device.js